const PRODUCT_QUERY_KEYS = "product";

export const productQueryKeys = {
  all: [PRODUCT_QUERY_KEYS] as const,
  byId: function byId(productId: number, includeExpired?: boolean) {
    return [PRODUCT_QUERY_KEYS, "byId", productId, includeExpired] as const;
  },
  byUid: function byUid(uniqueIdentifier: string, includeExpired?: boolean) {
    return [PRODUCT_QUERY_KEYS, "byUid", uniqueIdentifier, includeExpired] as const;
  },
  lean: function lean(citizenId: number | undefined, timestamp: number) {
    return [PRODUCT_QUERY_KEYS, "lean", citizenId, timestamp] as const;
  },
};
